import React from "react";
import { FiStar } from "react-icons/fi";

const StarRating = ({ rating = 0, reviewsCount }) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <div className="flex items-center gap-1.5">
      <div className="flex items-center text-chafadi-primary">
        {[...Array(fullStars)].map((_, i) => (
          <FiStar key={`full-${i}`} fill="currentColor" strokeWidth={2} className="text-sm" />
        ))}
        {halfStar && (
          <div className="relative overflow-visible">
            <FiStar fill="currentColor" strokeWidth={2} className="text-sm" />
            <div className="absolute inset-0 bg-theme-bg" style={{ clipPath: 'inset(0 0 0 50%)' }}>
               <FiStar strokeWidth={2} className="text-sm text-gray-200" />
            </div>
          </div>
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <FiStar key={`empty-${i}`} strokeWidth={2} className="text-sm text-gray-200" />
        ))}
      </div>
      {reviewsCount !== undefined && (
        <span className="text-[10px] font-black text-theme-muted uppercase tracking-widest ml-1">
          ({reviewsCount})
        </span>
      )}
    </div>
  );
};

export default StarRating;
